import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { CouponService } from "../../../../services/CouponService";
import { ChangeAlertCallbackType } from "../../../Root";
import { CouponsProps } from "../types";
import { CommonService } from "../../../../services/CommonService";

moment.locale('es');

export const useCouponsUpdate = (changeAlert: ChangeAlertCallbackType) => {

	const [partners, setPartners ] = useState(Array<{v:"", k: ""}>)
    const commonService = useRef<CommonService>();

    const [loading, setLoading] = useState(false);
    const couponService = useRef<CouponService>();

    const onGetCatalogPartner = async () => {
        setLoading(true);
		
        let data = {
			catalog: {
			    id: 'partners'
			}
		};

        const response = await commonService.current.getCatalog(data);

        if(response?.data?.response === 'OK'){
            setPartners(response.data.catalog)
            setLoading(false);
        } else {
            setLoading(false);
            changeAlert(true, 'error', response.data.message);
        }
	}

    const sendCoupons = async (data: CouponsProps) => {
        setLoading(true);

        const response = await couponService.current.couponsPartnerCreate(data);

        if(response.data?.response === 'OK'){
            setLoading(false);
            changeAlert(true, 'success', response.data.message);
        } else {
            setLoading(false);
            changeAlert(true, 'error', response.data.message);
        }
    };

    useEffect(() => {
        couponService.current = new CouponService(changeAlert)
        commonService.current = new CommonService(changeAlert)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const calculateColumns = useMemo(() => {
        const columns = [
            { selector: (row) => moment(row.vigencia.sdate).format("L"), name: "Fecha emisión", wrap: true, width: "15%", sortable: false },
            { selector: (row) => moment(row.vigencia.edate).format("L"), name: "Fecha vencimiento", wrap: true, width: "15%", sortable: false },
            { selector: (row) => row.partner, name: "Partner", wrap: true, width: "10%", sortable: false },
            { selector: (row) => row.campaign, name: "Campaña", wrap: true, width: "10%", sortable: false },
            { selector: (row) => row.cupones.map((i) => i + ", "), name: "Cupones", wrap: true, width: "50%", sortable: false },
        ]
        return columns
    }, [])

    return { columns: calculateColumns, loading, sendCoupons, onGetCatalogPartner, partners }

}
